import React, { FC, useEffect, useRef, useState } from 'react';
import { TextInput } from '@shared/uikit/input-text';
import { GrayButton } from '@shared/uikit/button';

interface IDropdownButtonProps {
  value: string;
  title: string;
  width?: number | string;
  className?: string | null;
  onSave: (value: any) => void;
  showValue?: boolean;
  onlyNumbers?: boolean;
}

const DropdownInput: FC<IDropdownButtonProps> = ({
  value,
  width,
  title,
  onSave,
  className = '',
  showValue,
  onlyNumbers,
}) => {
  const [isToggled, setIsToggled] = useState(false);
  const [newValue, setNewValue] = useState(value);
  const dropdownRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    function handler(e: Event) {
      if (dropdownRef.current) {
        // @ts-ignore
        if (!dropdownRef.current?.contains(e.target)) {
          setIsToggled(false);
        }
      }
    }
    document.addEventListener('click', handler);
    return () => {
      setNewValue('');
      document.removeEventListener('click', handler);
    };
  }, [dropdownRef?.current]);

  return (
    <div ref={dropdownRef} className={`relative`}>
      <div
        onClick={() => setIsToggled(!isToggled)}
        className={`flex items-center pl-[10px] h-[33px] align-middle cursor-pointer rounded-[8px] text-[12px] bg-[#211F24] text-[white] ${className} `}
        style={{
          minWidth: `${Number.isInteger(width) ? width + 'px' : width}`,
          maxWidth: `${Number.isInteger(width) ? width + 'px' : width}`,
        }}
      >
        {value ? (
          showValue ? (
            <>
              {title}
              <div className="absolute py-[2px] px-[4px] right-[5px] top-[5px] rounded-[4px] bg-[#2F2D33]">
                {value}
              </div>
            </>
          ) : (
            value
          )
        ) : (
          <>
            {title}
            <svg
              className="absolute right-[10px] top-[14px]"
              width="7"
              height="5"
              viewBox="0 0 7 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.71098 1.98938L4.18608 4.24524C3.80588 4.58492 3.19172 4.58492 2.81152 4.24524L0.286622 1.98939C-0.327542 1.44066 0.111146 0.500001 0.978776 0.500001L6.02857 0.5C6.8962 0.5 7.32514 1.44066 6.71098 1.98938Z"
                fill="white"
              />
            </svg>
          </>
        )}
      </div>
      <div
        className={`${isToggled ? 'visible' : 'invisible'} absolute rounded-[10px] w-[250px] bg-[#252328] px-[13px] py-[8px] top-[35px] -left-[15px] z-10`}
      >
        <div className="mb-[10px]">
          <TextInput
            width="100%"
            value={newValue}
            onChange={value => {
              if (onlyNumbers) {
                const numericRegex = /^[0-9]*$/;
                if (numericRegex.test(value)) {
                  setNewValue(value);
                }
              } else {
                setNewValue(value);
              }
            }}
            placeholder="Введите значение"
          />
        </div>
        <GrayButton
          onClick={() => {
            setIsToggled(false);
            onSave(newValue);
            setNewValue('');
          }}
          title="Сохранить"
        />
      </div>
    </div>
  );
};
export default DropdownInput;
